var _effectorFileName = "/builds/gmini/front-utils/src/createChildDomain.ts";
import { createDomain } from 'effector';
export var createChildDomain = function createChildDomain(parentDomain, name) {
  return parentDomain ? parentDomain.domain(name, {
    sid: "ltc1m2"
  }) : createDomain(name, {
    sid: "ltc3sf"
  });
};